import React, { useState } from "react";
import PropTypes from "prop-types";
import KpiReportFilter from "../../pages/reports/kpi-report/KpiReportFilter";
import { ltvReport, buttonName, monthlyKPIReportsData } from "../../locales/en";
import { useDispatch, useSelector } from "react-redux";
import { kpiReportsGenerateDownloadData } from "../../redux/userReportsSlice";
import GeneratedKPIDownloadTable from "../table/all-tables/reportable/monthlykpireport/modaltabel/download/GeneratedKPIDownloadTable";
import Style from "./modal.module.scss";
import "./modalstyle.scss";
import CommonModal from "./CommonModal";
import { ALL, MONTH, MONTH_12 } from "../../utils/constants/appConstants";
export default function KPIReportDownloadModal({ isOpen, toggle }) {
  const dispatch = useDispatch();
  const { kpiDownloadDataLoader } = useSelector((state) => state.userReport);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showNotification, setShowNotification] = useState(false);

  const initialValues = {
    viewType: MONTH,
    numberOfPeriods: MONTH_12,
    country: ALL,
    state: "",
    leadSource: "",
    referrerType: "",
    salesLead: "",
    withPercentage: false
  };

  const [values, setValues] = useState(initialValues);

  const handleGenerateReport = async () => {
    try {
      await dispatch(
        kpiReportsGenerateDownloadData({ payload: values })
      ).unwrap();
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 7000);
      setRefreshTrigger((prev) => prev + 1);
    } catch {
      // for catche part
    }
  };

  const handleOnClose = () => {
    toggle();
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={`${ltvReport?.downloadModal?.title}`}
      modalClassName={`${Style.xeroModal} modal-xl ltvReportDomldMdl kpireport_domldmdl`}
      bodyClassName={`${Style.aiScModalContent} modal-content`}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: handleOnClose
        }
      ]}
    >
      <div className="row flex-wrap mt-4 mb-3 justify-content-between search report_download">
        <KpiReportFilter values={values} setValues={setValues} />
      </div>
      <div className="mb-2 text-end">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleGenerateReport}
          disabled={kpiDownloadDataLoader}
        >
          {kpiDownloadDataLoader
            ? `${buttonName?.loading}`
            : `${buttonName?.generate}`}
        </button>
      </div>
      <div className="col-12">
        {showNotification && (
          <div className="dnld-notification mb-3 text-center">
            {monthlyKPIReportsData?.downloadModal?.notification}
          </div>
        )}
        <GeneratedKPIDownloadTable refreshTrigger={refreshTrigger} />
      </div>
    </CommonModal>
  );
}

KPIReportDownloadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};
